var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAQAAADYBBcfAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQfnAwoCBDZH2p/dAAAAyUlEQVQ4y62VPQqDQBSEx5hCrDyHlqYQa4+QK3gkwSNZmFJPIlaGL40B EXbN00yxzfDBvJ/dlZwiInK7N7elXPk5MFXqNu8eMPN4XrDQGRGzsBDbaywVKlRpB5+b0xA0YQJg IrGBDV81Fqxmq/rXkA17Nd7AxFS0a217TbRU2+EERMqVKlOhh8KDOG/16jRo1Oum67JF/UdzLo5j Rc8twIWVk2gBaO09rgCo7ODBRXY+HcFMLwWzGZTU+RL5wOEsOJobs7bH+wV8AEsT3sJi9Mq/AAAA JXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTAzLTEwVDAyOjA0OjU0KzAwOjAwxAy5HgAAACV0RVh0ZGF0 ZTptb2RpZnkAMjAyMy0wMy0xMFQwMjowNDo1NCswMDowMLVRAaIAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b77585ad97504079aeca56ee5b96b1fb.svg";
export { ForwardRef as ReactComponent };